var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconDownload02 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 19"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#fff",
  fillRule: "evenodd",
  clipRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.18 15.879V.333h1.416V15.88z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.887 16.66.883 9.202l.997-.917 7.007 6.53 7.007-6.53.998.917zM17.143 19H1.22v-1.293h15.922z"
}))));
export default SvgIconDownload02;